export default __webpack_public_path__ + "static/media/central_andes_2_15.c1616b46.JPG";